// src/extenders/cart-note.js
var CartNote = class extends HTMLElement {
  /**
   * Creates an instance of CartNote.
   * Initializes the elements and sets up event listeners for note updates and animations.
   */
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.textarea = this.querySelector("textarea");
    this.content = this.querySelector(".content");
    this.contentHeight = this.content.clientHeight;
    this.type = this.getAttribute("type");
    this.details.open = false;
    this.summary.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleDetails();
    });
    this.textarea.addEventListener("change", (e) => {
      const note = e.target.value;
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ note })
      }).then((response) => response.json()).then((cart) => {
        const event = new CustomEvent("cart:note:updated", {
          bubbles: true,
          detail: {
            note: cart.note,
            isOpen: this.details.open
          }
        });
        document.documentElement.dispatchEvent(event);
      });
    });
    document.documentElement.addEventListener("cart:note:updated", (e) => {
      if (e.target !== this) {
        this.textarea.value = e.detail.note;
        this.updateCartNote(e.detail.isOpen);
      }
    });
  }
  /**
   * Updates the cart note value across all cart-note instances except the current one.
   * @param {boolean} isOpen - Whether the cart note details element should be open
   */
  updateCartNote() {
    const cartNotes = document.querySelectorAll("cart-note");
    cartNotes.forEach((cartNote) => {
      if (cartNote !== this) {
        const textarea = cartNote.querySelector("textarea");
        textarea.value = this.textarea.value;
      }
    });
  }
  /**
   * Toggles the visibility of the cart note details with smooth animations.
   * Handles both opening and closing transitions.
   */
  toggleDetails() {
    const isOpen = this.details.open;
    if (!isOpen) {
      this.details.open = true;
      this.content.style.height = "0";
      this.textarea.style.opacity = "0";
      requestAnimationFrame(() => {
        this.content.style.height = `${this.contentHeight + 24}px`;
        setTimeout(() => {
          this.textarea.style.opacity = "1";
        }, 150);
        this.textarea.focus();
      });
    } else {
      this.content.style.height = `${this.contentHeight + 24}px`;
      this.textarea.style.opacity = "1";
      requestAnimationFrame(() => {
        this.content.style.height = "0";
        this.textarea.style.opacity = "0";
      });
      this.content.addEventListener("transitionend", () => {
        this.details.open = false;
        this.content.style.height = "";
      }, { once: true });
    }
  }
};
if (customElements.get("cart-note") === void 0) {
  customElements.define("cart-note", CartNote);
}
